"use client";

import type { LinkProps } from "./Link";

import { Link } from "./Link";

interface TrackableLinkProps extends LinkProps {
  onLinkClick?: (href: string) => void;
}

export const TrackableLink = ({
  onLinkClick,
  href,
  children,
  ...props
}: TrackableLinkProps) => {
  const handleClick = () => {
    if (onLinkClick && href) {
      onLinkClick(href.toString());
    }
  };

  return (
    <Link href={href} onClick={handleClick} {...props}>
      {children}
    </Link>
  );
};
